export const BASE_URL = 'https://hyphen-test-api.biconomy.io/';
